<button
  class="node-container circle"
  [ngClass]="[
    !disabled ? focusClass + ' enabled' : focusClass,
    isPreK2Reading ? 'prek2-reading' : ''
  ]"
  id="progress-bar-node-container"
  data-testid="htc-progress-node-container"
  [tabIndex]="!disabled ? 0 : -1"
  (click)="onNodeClicked()"
  [disabled]="disabled">
  <div
    class="node-bg circle center ignore-pointer-events"
    data-testid="htc-progress-node-bg"></div>
  <div
    class="node-text center ignore-pointer-events"
    data-testid="htc-progress-node-text">
    {{ data.text }}
  </div>
  @if (focusClass === 'active' && isPreK2Reading) {
    <svg-icon
      class="chibi-spot-icon"
      src="assets/progress-node-icons/chibiSpot.svg"></svg-icon>
  }

  @if (!isPreK2Reading) {
    <div class="status-container">
      @switch (statusClass) {
        @case ('wrong') {
          <htc-status-wrong
            data-testid="htc-wrong-progress-node"
            class="node-img circle center ignore-pointer-events"
            [ngClass]="statusClass"></htc-status-wrong>
        }
        @case ('correct') {
          <htc-status-correct
            data-testid="htc-correct-progress-node"
            class="node-img circle center ignore-pointer-events"
            [ngClass]="statusClass"></htc-status-correct>
        }
        @case ('perfect') {
          <htc-status-perfect
            data-testid="htc-perfect-progress-node"
            class="node-img circle center ignore-pointer-events"
            [ngClass]="statusClass"></htc-status-perfect>
        }
        @case ('complete') {
          <htc-status-complete
            data-testid="htc-complete-progress-node"
            class="node-img circle center ignore-pointer-events"
            [ngClass]="statusClass"></htc-status-complete>
        }
      }
    </div>
  } @else {
    @if (
      ['complete', 'perfect', 'correct', 'wrong'].includes(statusClass) &&
      focusClass !== 'active'
    ) {
      <div
        class="status-container circle center ignore-pointer-events prek2-complete-node">
        <svg-icon
          class="prek2-progress-fill-icon"
          src="assets/progress-node-icons/prek2-progress-fill.svg"></svg-icon>
      </div>
    }
  }
</button>
